import { useTheme } from '../../../redux/hooks/useTheme';
import { useNavigate } from 'react-router-dom';


export function ScreenSizePopUp() {
  const {theme}=useTheme();

const navigate=useNavigate();
  const handleClicktoDashboard = () => {
    navigate('/');
  };
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4">
        <div style={{display:'flex',flexDirection:'column', justifyContent:'center', alignItems:'center'}} className="bg-white dark-bg-class rounded-2xl p-8 w-[582px] space-y-8 relative animate-in fade-in zoom-in duration-300">
          {/* Icon container */}
          <div style={{background: theme.iconBackground}} className="text-4xl icon w-[54px] h-[54px] rounded-[8px] flex items-center justify-center text-xl ">
            <span className="text-3xl text-[#FF4D6A]">
              
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 9.98V9C2 4 4 2 9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22H14" stroke="url(#paint0_linear_1544_12087)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13 11L18.01 5.98001H14" stroke="url(#paint1_linear_1544_12087)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.0098 5.98001V9.99001" stroke="url(#paint2_linear_1544_12087)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11 16.15V18.85C11 21.1 10.1 22 7.85 22H5.15C2.9 22 2 21.1 2 18.85V16.15C2 13.9 2.9 13 5.15 13H7.85C10.1 13 11 13.9 11 16.15Z" stroke="url(#paint3_linear_1544_12087)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
            <linearGradient id="paint0_linear_1544_12087" x1="22" y1="22" x2="2.99395" y2="2.00575" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FB5F65"/>
            <stop offset="1" stopColor="#F378C9"/>
            </linearGradient>
            <linearGradient id="paint1_linear_1544_12087" x1="20" y1="22.5" x2="1.95538" y2="3.04138" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FB5F65"/>
            <stop offset="1" stopColor="#F378C9"/>
            </linearGradient>
            <linearGradient id="paint2_linear_1544_12087" x1="35" y1="18.5" x2="21.5048" y2="28.3508" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FB5F65"/>
            <stop offset="1" stopColor="#F378C9"/>
            </linearGradient>
            <linearGradient id="paint3_linear_1544_12087" x1="22" y1="22" x2="1.99397" y2="2.00603" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FB5F65"/>
            <stop offset="1" stopColor="#F378C9"/>
            </linearGradient>
            </defs>
            </svg>

            </span>
          </div>
          
          {/* Text content */}
          <div className="text-center pt-[12px] mt-login-popup">
            <h2 style={{fontWeight:700, fontSize:'24px', lineHeight:'30px', color:theme.loginPopupHeading}} className="text-[18px] pt-[12px] text-gray-900">Screen Too Small</h2>
            <p style={{fontSize:'18px', fontWeight:'400', lineHeight:'27px', paddingTop:'10px', color:theme.loginPopupSubHeading}} className="">
             Access it through desktop device
            </p>
          </div>
  
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 ">
          <button
          onClick={handleClicktoDashboard}
          className="px-8 py-3 pop-up-btn rounded-lg border border-[#FF4D6A] text-white text-[16px] font-medium  hover:from-[#FF89A3] hover:to-[#FF4D6A] transition-colors duration-200"
        >
          Go to Dashboard
        </button>

          </div>
        </div>
      </div>
    );
  };